<app-loader *ngIf="loader"></app-loader>
<section>
  <nav class="navbar navbar-expand-lg navbar-light transparent mt-2">
    <div class="col-12 p-0 d-flex align-items-center">
      <a routerLink="/dashboard">
        <img src="../../../assets/img/redback.png" alt="back" /><span
          class="title_get"
          class="title_get ml-2"
          >Back</span
        ></a
      >
      <div class="col-6 p-0 d-flex align-items-center justify-content-end">
        <span class="font-weight-bold text-dark text-center">Bot</span>
      </div>
    </div>
  </nav>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-12">
        <div class="bot_details">
          Bot info
          <a style="cursor: pointer"
            ><i class="fas fa-chevron-right" (click)="botDetails()"></i
          ></a>
        </div>
      </div>
      <div class="col-12">
        <div class="bot_details">
          Home details
          <a style="cursor: pointer"
            ><i class="fas fa-chevron-right" (click)="homeDetails()"></i
          ></a>
        </div>
      </div>
      <div class="col-12">
        <div class="bot_details">
          Utility details
          <a style="cursor: pointer"
            ><i class="fas fa-chevron-right" (click)="utilityDetails()"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
</section>
